import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

// --- CSS THEME MATCHING "List of Doctors" Page ---
const css = `
.special-offer-container {
  background: #fff;
  border: 1.5px solid #eee;
  box-shadow: 0 3px 16px #16233808;
  border-radius: 18px;
  padding: 2.1rem 2.2rem;
  margin-top: 36px;
  max-width: 950px;
  margin-left: auto;
  margin-right: auto;
}
.special-offer-header {
  font-size: 2.0rem;
  font-weight: 700;
  color: #2c2c2c;
  margin-bottom: 0.25rem;
  letter-spacing: 0;
}
.breadcrumb {
  background: transparent;
  padding: 0;
  margin-bottom: 2rem;
  font-size: 1.01rem;
}
.breadcrumb .breadcrumb-item a {
  color: #2796ff;
  text-decoration: underline;
  font-weight: 500;
  transition: color .15s;
}
.breadcrumb .breadcrumb-item.active {
  color: #7a868e;
}
.breadcrumb-item + .breadcrumb-item::before {
  color: #dadada;
}

.label {
  color: #222;
  font-weight: 600;
  margin-bottom: 5px;
  font-size: 1.06rem;
}
input[type="text"], input[type="date"], input[type="number"], textarea, .form-select {
  border: 1.3px solid #e8e8e8 !important;
  border-radius: 7px !important;
  font-size: 1.06rem;
  background: #fcfcfc !important;
  color: #2c2c2c !important;
  transition: border .15s;
}
input[type="text"]:focus, input[type="date"]:focus, input[type="number"]:focus, textarea:focus, .form-select:focus {
  border: 1.4px solid #2796ff !important;
  background: #f7fbff !important;
  outline: none;
}
input[type="file"]::file-selector-button {
  background: #74b1cfff;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 5px 20px;
  font-weight: 600;
  font-size: 1rem;
  margin-right: 10px;
  cursor: pointer;
}
input[type="file"]::file-selector-button:hover {
  background: #74b1cfff;
}

.display-img-area {
  width: 92px; height: 92px;
  background: #f4f4f4;
  border: 1.2px solid #ebebeb;
  border-radius: 9px;
  display: flex; align-items: center; justify-content: center;
  box-shadow: 0 1px 7px #b1b1b11a;
  margin-top: 4px;
}
.display-img-area img {
  width: 100%; height: 100%; border-radius: 8px; object-fit: cover;
}
.section-row {
  display: flex; gap: 22px; justify-content: flex-start; flex-wrap: wrap;
  margin-bottom: 18px;
}
.section-row > * { flex: 1; min-width: 170px; }
@media (max-width: 991px) { .section-row { flex-direction: column; gap: 2px; } }

#list-area {
  min-height: 74px;
  background: #fafbfb;
  border: 1.5px dashed #d2d7db;
  border-radius: 7px;
  padding: 16px;
  color: #b6bdc2;
  font-size: 1.02rem;
  font-weight: 500;
  margin-bottom: 1.7rem;
  margin-top: 18px;
}

.button-row {
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  margin-top: 8px;
}
.special-btn {
  background: #74b1cfff;
  color: #fff;
  border: none;
  border-radius: 7px;
  font-weight: 700;
  font-size: 1rem;
  padding: 9px 32px;
  box-shadow: 0 2px 8px #2796ff07;
  transition: background .16s;
  letter-spacing: .04em;
}
.special-btn:active, .special-btn:focus {
  background: #74b1cfff;
  color: #fff;
}
.cancel-btn {
  background: none;
  border: 1.3px solid #b8c1cc;
  color: #828f9a;
  font-weight: 600;
  transition: background .17s, color .13s;
}
.cancel-btn:hover {
  background: #f4f7fa;
  color: #2763bb;
}
  
.label {
  margin-bottom: 7px;
}
  
`;

const typesMenuOptions = [
  { value: '', label: 'None' },
  { value: 'global', label: 'Global' },
  { value: 'local', label: 'Local' }
];
const assigneeTypeOptions = [
  { value: '', label: 'None' },
  { value: 'doctor', label: 'Doctor' },
  { value: 'patient', label: 'Patient' }
];
const rewardForPatientOptions = [
  { value: '', label: 'None' },
  { value: 'onCountAppointments', label: 'On count of appointments' },
  { value: 'onFamilyCount', label: 'On family count' },
  { value: 'onRevenueAppointments', label: 'On revenue of appointments' }
];
const rewardForDoctorOptions = [
  { value: '', label: 'None' },
  { value: 'numAppointments', label: 'No. of Appointments' },
  { value: 'revenueAppointments', label: 'Revenue of Appointments' },
  { value: 'numArticles', label: 'No. of Articles' },
  { value: 'viewsArticles', label: 'Views on Articles' }
];
const rewardTypeOptions = [
  { value: '', label: 'None' },
  { value: '%', label: '%' },
  { value: 'money', label: 'Money' },
  { value: 'validity', label: 'Validity' }
];
const assignToOptions = [
  { value: 'all', label: 'All' },
  { value: 'doctor', label: 'Doctor' },
  { value: 'patient', label: 'Patient' }
];

export default function SpecialOfferConfigPage() {
  const [preview, setPreview] = useState(null);
  const [form, setForm] = useState({
    startDate: '', endDate: '',
    title: '', description: '',
    typesMenu: '', assigneeType: '',
    rewardForPatient: '', rewardForDoctor: '',
    countStart: '', countEnd: '', rewardType: '', assignTo: ''
  });

  // Instant image preview handler
  const handleImageChange = (e) => {
    if (e.target.files?.[0]) {
      const file = e.target.files[0];
      const reader = new FileReader();
      reader.onloadend = () => setPreview(reader.result);
      reader.readAsDataURL(file);
    } else setPreview(null);
  };

  const handleChange = (field) => (e) =>
    setForm((prev) => ({ ...prev, [field]: e.target.value }));

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Offer submitted! (Demo: values not persisted)");
  };
  const handleCancel = () => {
    setForm({
      startDate: '', endDate: '', title: '', description: '',
      typesMenu: '', assigneeType: '', rewardForPatient: '',
      rewardForDoctor: '', countStart: '', countEnd: '',
      rewardType: '', assignTo: ''
    });
    setPreview(null);
  };

  return (
    <>
      <style>{css}</style>

      <div className="col-12 col-md-7 col-lg-8 col-xl-9">
        <div className="page-wrapper">
          <div className="content container-fluid px-0">
            <h2><div className="special-header">Special Offer</div> </h2>   
            {/* Breadcrumbs */}
            <nav style={{ marginBottom: 0 }}>
              <ol className="breadcrumb ms-1">
                <li className="breadcrumb-item"><a href="#">Dashboard</a></li>
                <li className="breadcrumb-item"><a href="#">Offers</a></li>
                <li className="breadcrumb-item active" aria-current="page">Special Offer</li>
              </ol>
            </nav>

            <form className="special-offer-container mb-4" onSubmit={handleSubmit}>
              {/* Top Row: Upload and Date fields */}
              <div className="section-row align-items-end mb-4">
                {/* Upload + Display */}
                <div style={{ maxWidth: "180px" }}>
                  <label className="label">Upload image</label>
                  <input type="file" accept="image/*" onChange={handleImageChange} />
                  <label className="label mt-1">Display image</label>
                  <div className="display-img-area mt-1">
                    {preview
                      ? (<img src={preview} alt="selected" />)
                      : (<span style={{ color: "#bcbcbc", fontSize: "0.97rem" }}>No Image</span>)}
                  </div>
                </div>

                {/* Date fields */}
                <div>
                  <label className="label">Start Date</label>
                  <input
                    type="date"
                    className="form-control"
                    value={form.startDate}
                    onChange={handleChange('startDate')}
                  />
                </div>

                <div>
                  <label className="label">End Date</label>
                  <input
                    type="date"
                    className="form-control"
                    value={form.endDate}
                    onChange={handleChange('endDate')}
                  />
                </div>
              </div>

              {/* Title */}
              <div className="mb-3">
                <label className="label">Title</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Title"
                  value={form.title}
                  onChange={handleChange('title')}
                />
              </div>

              {/* Description */}
              <div className="mb-3">
                <label className="label">Description</label>
                <textarea
                  className="form-control"
                  rows={2}
                  placeholder="Description"
                  value={form.description}
                  onChange={handleChange('description')}
                />
              </div>

              {/* Types/Menu & Assignee Type */}
              <div className="section-row">
                <div>
                  <label className="label">Types/Menu</label>
                  <select
                    className="form-select"
                    value={form.typesMenu}
                    onChange={handleChange('typesMenu')}
                  >
                    {typesMenuOptions.map(opt => (
                      <option key={opt.value} value={opt.value}>{opt.label}</option>
                    ))}
                  </select>
                </div>

                <div>
                  <label className="label">Assignee Type</label>
                  <select
                    className="form-select"
                    value={form.assigneeType}
                    onChange={handleChange('assigneeType')}
                  >
                    {assigneeTypeOptions.map(opt => (
                      <option key={opt.value} value={opt.value}>{opt.label}</option>
                    ))}
                  </select>
                </div>
              </div>

              {/* Reward sections */}
              <div className="section-row">
                <div>
                  <label className="label">Reward For Patient</label>
                  <select
                    className="form-select"
                    value={form.rewardForPatient}
                    onChange={handleChange('rewardForPatient')}
                  >
                    {rewardForPatientOptions.map(opt => (
                      <option key={opt.value} value={opt.value}>{opt.label}</option>
                    ))}
                  </select>
                </div>

                <div>
                  <label className="label">Reward For Doctor</label>
                  <select
                    className="form-select"
                    value={form.rewardForDoctor}
                    onChange={handleChange('rewardForDoctor')}
                  >
                    {rewardForDoctorOptions.map(opt => (
                      <option key={opt.value} value={opt.value}>{opt.label}</option>
                    ))}
                  </select>
                </div>
              </div>

              {/* Count & Reward Type */}
              <div className="section-row align-items-end">
                <div>
                  <label className="label">Count greater than</label>
                  <div className="d-flex gap-2">
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Starting"
                      value={form.countStart}
                      onChange={handleChange('countStart')}
                      min={0}
                    />
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Ending"
                      value={form.countEnd}
                      onChange={handleChange('countEnd')}
                      min={0}
                    />
                  </div>
                </div>

                <div>
                  <label className="label">Reward Type</label>
                  <select
                    className="form-select"
                    value={form.rewardType}
                    onChange={handleChange('rewardType')}
                  >
                    {rewardTypeOptions.map(opt => (
                      <option key={opt.value} value={opt.value}>{opt.label}</option>
                    ))}
                  </select>
                </div>
              </div>

              {/* Assign To */}
              <div style={{ maxWidth: 360 }}>
                <label className="label">Assign To</label>
                <select
                  className="form-select"
                  value={form.assignTo}
                  onChange={handleChange('assignTo')}
                >
                  {assignToOptions.map(opt => (
                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                  ))}
                </select>
              </div>

              {/* List placeholder */}
              <div id="list-area">List</div>

              {/* Buttons */}
              <div className="button-row">
                <button
                  type="button"
                  className="special-btn cancel-btn"
                  onClick={handleCancel}
                >
                  Cancel
                </button>
                <button type="submit" className="special-btn">Submit</button>
              </div>
            </form>

          </div>
        </div>
      </div>


    </>
  );
}
